module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/chiba_funabashi_point4_3-ac645fb5d0eea0935c152fb8442eb8ea.jpg";